import { useEffect, useRef, useState } from "react"
import { composeImgURL } from "../components/homeGridBlock.component"
import { Bijoux, BijouxItem } from '../pages/home.page'
import { LightBox } from '../pages/collection.page'
import bijouxJson from "../data/bijoux.json"


export function BijouxPage() {
    const [bijoux, setBijoux] = useState<Bijoux>();
    const [lbImages, setLbImages] = useState<string[]>();
    const [targetIDX, setTargetIDX] = useState<string | null>(null);

    useEffect(() => {
        setBijoux(bijouxJson);
        let img_urls: string[] = []
        bijouxJson.collectionData.forEach((cd: BijouxItem) => {
            img_urls.push(...cd.images)
        });
        setLbImages(img_urls)
    }, [targetIDX])


    return (
        <>
        { (lbImages && bijoux?.folder) && <LightBox urls={lbImages} folder={bijoux?.folder} target={targetIDX} /> }

        <div className="row g-0">
            <div className="col-12 col-md-4 offset-md-4 mt-2 p-3 text-center">
                <h2>Bijoux</h2>
                <p>
                    { bijoux?.description }
                </p>
            </div>
        </div>
        <div className="row g-0 bt">
            {
                bijoux?.collectionData.map((item: BijouxItem, idx) => {
                    return (
                        <BijouxItemComponent
                        key={idx}
                        title={item.title}
                        folder={bijoux.folder}
                        images={item.images} 
                        price={item.price}
                        setTargetIDX={setTargetIDX}
                        />
                    )
                })
            }
        </div>
        <div className="row g-0"></div>
        </>
    )
}

type BijouxItemComponentProps = {
    images: string[],
    folder: string,
    title: string,
    price: string,
    setTargetIDX: (t: string) => void
}

function BijouxItemComponent(props: BijouxItemComponentProps) {
    const [images, setImages] = useState<string[]>([])
    const [idx, setIdx] = useState(0);

    useEffect(() => {
        setImages(props.images);
        setIdx(0);
    }, [props])

    return (
        <div className="col-12 col-md-3 border-col">
            {
                (props.images.length > 1) ? (
                    <div className="carousel slide" data-ride="carousel" style={{padding: "20px"}}>
                        <div className="carousel-inner" onClick={(e) => props.setTargetIDX(props.images[0])}>
                            {
                                props.images.map((i: string) => {
                                    return (
                                        <div key={i} className={"carousel-item" + ((idx % images.length == images.indexOf(i)) ? " active" : "" )} style={{border: "none"}}>
                                            <img className="d-block w-100" src={'../' + composeImgURL(props.folder, i)} />
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <button className="carousel-control-prev" onClick={(e) => setIdx(idx - 1)} type="button">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" onClick={(e) => setIdx(idx + 1)} type="button">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                ) : (
                        <img 
                            className="img-fluid" style={{width: "100%", padding: "20px"}}
                            src={'../' + composeImgURL(props.folder, props.images[0])}
                        />
                )
            }
            {
                (props.title && props.title !== "") && (
                    <div className="p-3 bt">
                        <p className="mb-0" style={{fontSize: "20px"}}>{props.title}</p>
                    </div>
                )
            }
        </div>
    )
}